/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Give_1Inputs */

const en_cp_give_1 = /** @type {(inputs: Cp_Give_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 90-minute kickoff (online/on site) with a script and demo team accounts`)
};

const id_cp_give_1 = /** @type {(inputs: Cp_Give_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kickoff 90 menit (daring/luring) dengan naskah dan akun demo tim`)
};

/**
* | output |
* | --- |
* | "A 90-minute kickoff (online/on site) with a script and demo team accounts" |
*
* @param {Cp_Give_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_give_1 = /** @type {((inputs?: Cp_Give_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Give_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_give_1(inputs)
	return en_cp_give_1(inputs)
});